"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var SvgZoomPlusOutline = function (props) { return (react_1.default.createElement("svg", __assign({ width: '1em', height: '1em', viewBox: '0 0 24 24' }, props),
    react_1.default.createElement("path", { clipRule: 'evenodd', d: 'M14.605 13.194l7 6.998a1 1 0 01-1.414 1.414h-.001l-6.997-7a7 7 0 111.412-1.412zM9 14A5 5 0 109 4a5 5 0 000 10zm1-7v1h1c.667.005 1 .338 1 1 0 .662-.333.993-1 .993L10 10v1c.001.667-.332 1-1 1-.668 0-1.001-.333-1-1l-.006-.983L7 9.993c-.667 0-1-.333-1-1 0-.666.333-.998 1-.993h1V7c0-.667.334-1 1.002-1 .668 0 1 .333.998 1z' }))); };
exports.default = SvgZoomPlusOutline;
//# sourceMappingURL=ZoomPlusOutline.js.map